export default {
  fields: {
    name: 'Név',
    wapps: 'WAPPS',
    gtin: 'GTIN',
    expiresAt: "Lejárati dátum",
    lotNo: "Tétel szám",
    takeAmount: "Faktormennyiség"
  }
}